import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Divider, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { approveAIContent, editAIContent, fetchAIContents } from '../../../store/aiContentSlice';
import { BLOG_INTEGRATIONS, IMAGE_INTEGRATIONS, VIDEO_INTEGRATIONS } from '../../../utils/constant';
import { use } from 'react';
import { fetchDomainList } from '../../../store/domainSlice';

export default function AIContentForm({ title, aicontent, aiContentModal, setAIContentModal, allIntegrationNames, getAIContentData, selectedContent = null, type }) {
    const dispatch = useDispatch();
    console.log("type", type);

    const domains = useSelector((state) => state.domainReducer.domainList);
    const validationSchema = Yup.object().shape({
        caption: Yup.string().when([], {
            is: () => type !== 'blog',
            then: (schema) => schema.required("Caption is required"),
            otherwise: (schema) => schema.notRequired(),
        }),

        // caption: Yup.string().required("Caption is required"),
        integration: Yup.array().required("source is required"),
        contact_info: Yup.string().required("Domain is required"),
    });
    console.log("allIntegrationNames", allIntegrationNames);

    React.useEffect(() => {
        dispatch(fetchDomainList()).then(() => {
            console.log("AI Contents fetched successfully");
        })
    }, [])
    const formik = useFormik({
        initialValues: {
            caption: "",
            integration: [],
            contact_info: "",
        },
        validationSchema, // Use the static one defined above
        onSubmit: async (values, { resetForm }) => {
            setAIContentModal(false);
            try {
                let cleanedCaption
                if (values.caption) {
                    cleanedCaption = values.caption.replace(/\{.*?\}/g, '{}');

                    // cleanedCaption = values.caption?.replace(/\{(.*?)\}/g, '$1'); // keeps content, removes braces

                }
                const payload = {
                    ...values,
                    caption: cleanedCaption
                };
                const { integration, ...filteredPayload } = payload;

                await dispatch(editAIContent({ id: selectedContent.uuid, values: filteredPayload })).then(() => {
                });
                await dispatch(approveAIContent({ uuid: selectedContent.uuid, integration: values.integration.filter((item) => item !== 'all') })).then(() => {
                });
                getAIContentData()
                resetForm();
            } catch (error) {
                toast.error("Something went wrong. Please try again.",);
            } finally {
            }
        }
    });
    useEffect(() => {
        if (aiContentModal) {
            if (selectedContent) {
                console.log("selectedContent.caption", selectedContent.caption);

                formik.setValues({
                    caption: selectedContent.caption || "",
                    contact_info: selectedContent.contact_info || "",
                    integration: selectedContent.integration || [],
                });
            } else {
                formik.resetForm();
            }
        }
    }, [aiContentModal, selectedContent]);

    const allOptionId = 'all';
    const allLabel = 'All';

    const getIntegrationsByMediaType = (mediaType) => {
        switch (mediaType) {
            case 'video':
                return VIDEO_INTEGRATIONS;
            case 'image':
                return IMAGE_INTEGRATIONS;
            case 'blog':
                return BLOG_INTEGRATIONS;
            default:
                return [];
        }
    }
    // useEffect(() => {
    //     if (aiContentModal && formik.values.contact_info) {
    //         const selectedDomain = domains.find(domain => domain.id === formik.values.contact_info);
    //         const route = selectedDomain?.route || "";

    //         const currentCaption = formik.values.caption || "";
    //         const updatedCaption = currentCaption.replace(/\{.*?\}/g, formik.values.contact_info.toString());

    //         formik.setFieldValue("caption", updatedCaption || route);

    //         // formik.setFieldValue("caption", selectedContent.caption || "");
    //     }
    // }, [formik.values.contact_info]);

    useEffect(() => {
        if (aiContentModal && formik.values.contact_info) {
            // const selectedDomain = domains.find(domain => domain.id === formik.values.contact_info);
            const route = formik?.values?.contact_info || "";

            const currentCaption = formik.values.caption || "";

            // Replace exactly "{}" or anything inside curly braces with the route
            console.log("currentCaption", currentCaption);

            const updatedCaption = currentCaption.replace(/\{.*?\}/g, `{${route}}`);
            console.log("updatedCaption", updatedCaption);


            formik.setFieldValue("caption", updatedCaption);
        }
    }, [formik.values.contact_info]);
    //   const handleCaptionChange = (event) => {
    //     const input = event.target.value;

    //     // Ensure it always contains {} (at least once)
    //     if (!input.includes('{') || !input.includes('}')) {
    //       return; // block the update if {} is being removed
    //     }

    //     // Optionally: Add more rules like only 1 set of {}
    //     formik.setFieldValue('caption', input);
    //   };
    const handleCaptionChange = (event) => {
        const input = event.target.value;
        const original = formik.values.caption;

        const matchOriginal = original.match(/\{.*?\}/);
        const matchInput = input.match(/\{.*?\}/);
        // If original had a {route} and input doesn't, reject
        if (formik.values.contact_info) {
            if (!matchInput || !matchOriginal) return;
            if (matchInput[0] !== matchOriginal[0]) return;
        }

        // Accept the update
        formik.setFieldValue('caption', input);
    };



    return (
        // <CommentDrawer open={aiContentModal} setOpen={setAIContentModal} onClose={() => setAIContentModal(false)} title={title}>
        <Box className="p-3 position-relative h-100">
            <form onSubmit={formik.handleSubmit}>

                <FormControl
                    fullWidth
                    required
                    className="mt-2"
                    label="Contact info"
                    error={formik.touched.contact_info && Boolean(formik.errors.contact_info)}
                >
                    <InputLabel id="contact_info">Domain</InputLabel>

                    <Select
                        label="Domain"
                        id="contact_info"
                        name="contact_info"
                        value={formik.values.contact_info}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.contact_info && Boolean(formik.errors.contact_info)}
                    >
                        {domains?.length === 0 ? (
                            <MenuItem disabled>No domains found.</MenuItem>
                        ) : (
                            domains?.map((ele) => (
                                <MenuItem key={ele.id} value={ele.route}>
                                    <ListItemText primary={ele.route} />
                                </MenuItem>
                            ))
                        )}
                    </Select>
                </FormControl>
                <FormHelperText>
                    {formik.touched.contact_info && formik.errors.contact_info}
                </FormHelperText>
                {type !== 'blog' && (
                    <TextField
                        fullWidth
                        required
                        multiline
                        className='mt-3'
                        minRows={4}
                        id="caption"
                        name="caption"
                        label="Caption"
                        value={formik.values.caption}
                        onChange={handleCaptionChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.caption && Boolean(formik.errors.caption)}
                        helperText={formik.touched.caption && formik.errors.caption}
                    />)}
                <FormControl
                    fullWidth
                    required
                    className="mt-3"
                    label="Integration"
                    error={formik.touched.integration && Boolean(formik.errors.integration)}
                >
                    <InputLabel id="industry_ids">Source</InputLabel>

                    <Select
                        name="integration"
                        multiple
                        label="Source"
                        id="Integration"
                        value={formik.values.integration}
                        onChange={(e) => {
                            const value = e.target.value;
                            const isAllSelected = value.includes(allOptionId);
                            const wasAllSelected = formik.values.integration.includes(allOptionId);
                            const justClickedAll = isAllSelected && !wasAllSelected;
                            const justUnclickedAll = !isAllSelected && wasAllSelected;
                            let newValue = [];
                            if (justClickedAll) {
                                newValue = [allOptionId, ...allIntegrationNames];
                            } else if (justUnclickedAll) {
                                newValue = [];
                            } else {
                                const filtered = value.filter(val => val !== allOptionId);
                                newValue = filtered.length === allIntegrationNames.length
                                    ? [allOptionId, ...filtered]
                                    : filtered;
                            }
                            formik.setFieldValue("integration", newValue);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.integration && Boolean(formik.errors.integration)}
                        renderValue={(selected) => {
                            if (selected.length === 0) {
                                return <Typography color="textSecondary">Select Source</Typography>;
                            }
                            return (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                    {selected
                                        .filter(id => id !== allOptionId)
                                        .map((name) => (
                                            <Chip
                                                key={name}
                                                label={name}
                                                onMouseDown={(event) => event.stopPropagation()}
                                                onDelete={() => {
                                                    const updated = selected.filter(item => item !== name && item !== allOptionId);
                                                    formik.setFieldValue("integration", updated);
                                                }}
                                            />
                                        ))}
                                </Box>
                            );
                        }}
                        MenuProps={{
                            PaperProps: {
                                className: "mui-select-menu",
                            },
                        }}
                    >
                        <MenuItem key={allOptionId} value={allOptionId}>
                            <Checkbox checked={formik.values.integration.includes(allOptionId)} />
                            <ListItemText primary={allLabel} />
                        </MenuItem>

                        {(getIntegrationsByMediaType(aicontent?.media_type) || []).map((ele) => (
                            <MenuItem key={ele.key} value={ele.key}>
                                <Checkbox checked={formik.values.integration.includes(ele.key)} />
                                <ListItemText primary={ele.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {/* Optional HelperText for Validation */}
                {formik.touched.integration && formik.errors.integration && (
                    <FormHelperText className='text-danger'>
                        {formik.errors.integration}
                    </FormHelperText>
                )}

                <Box className="d-flex justify-content-end mt-3">
                    <Button
                        type="button"
                        variant="outlined"
                        color="primary"
                        onClick={() => setAIContentModal(false)}
                        className="mt-2 mr-2"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="mt-2"
                        disabled={formik.isSubmitting || !(formik.dirty && formik.isValid)}
                    >
                        Save
                    </Button>
                </Box>
            </form>
        </Box>
        // </CommentDrawer>
    );
}
